import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from '../Text';
import Styles from './InputsField.styles';
import { WHITE } from '../../../constants/colors';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const Label = styled(Text).attrs({ bold: true })`${Styles.label}`; // prettier-ignore
const Input = styled.input`${Styles.input}`; // prettier-ignore

/**
 * Inputs field component
 * @param {Object} param - props
 * @returns {JSX}
 */
const InputsField = ({
  type,
  label,
  className,
  placeHolder,
  reference,
  value,
  onChange,
  name,
  status,
  fixAutofill,
  disableAutocomplete,
  autoComplete,
  isRequired,
  accept,
  labelPosition = 'bottom',
  style,
}) => {
  return (
    <Wrapper className={className} fixAutofill={fixAutofill}>
      {labelPosition === 'top' ? <Label style={{ color: '#272031', fontFamily: 'Gotham-Book', fontSize: 14, marginBottom: 12 }}>{label}</Label> : null}
      {type === 'area' ? (
        <textarea
          accept={accept}
          placeholder={placeHolder}
          innerRef={reference}
          value={value}
          name={name}
          onChange={onChange}
          autoComplete={disableAutocomplete ? 'off' : autoComplete}
          required={isRequired}
          style={style}
        ></textarea>
      ) : (
        <Input
          accept={accept}
          type={type}
          placeholder={placeHolder}
          innerRef={reference}
          value={value}
          name={name}
          onChange={onChange}
          autoComplete={disableAutocomplete ? 'off' : autoComplete}
          required={isRequired}
          style={style}
        />
      )}
      {labelPosition === 'bottom' ? <Label status={status}>{label}</Label> : null}
    </Wrapper>
  );
};

InputsField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  reference: PropTypes.object,
  name: PropTypes.string,
  status: PropTypes.number,
  fixAutofill: PropTypes.string,
  disableAutocomplete: PropTypes.bool,
  autoComplete: PropTypes.string,
  isRequired: PropTypes.bool,
};

InputsField.defaultProps = {
  type: 'text',
  fixAutofill: WHITE,
  autoComplete: 'on',
};

export default InputsField;
